// extracted by mini-css-extract-plugin
export default {"container":"searchBar_container__cVA4c","input":"searchBar_input__SVHbA"};